import React, { useMemo } from "react";
import { Avatar } from "../../Avatar";
import IconAvatar from "../components/IconAvatar";
import { ACTIONS } from "../constants";
import { getBrand, getInitials, getTimes } from "../logic";
import { jsx as _jsx } from "react/jsx-runtime";
var useAuditTrail = function useAuditTrail(item) {
  var time = getTimes(item.dateTime);
  var initials = getInitials(item.name, item.forcedInitials);
  var _ref = item.action !== "custom" ? ACTIONS[item.action] : item.actionProps,
    actionName = _ref.actionName,
    preposition = _ref.preposition,
    fallbackIcon = _ref.fallbackIcon,
    forceIcon = _ref.forceIcon;
  var brandIcon = getBrand(item.name);
  var auditHistory = useMemo(function () {
    var result = actionName || "";
    if (item.name) {
      result += " ".concat(preposition, " ").concat(item.name);
    }
    if (item.source) {
      result += item.name ? " (using ".concat(item.source, ")") : " using ".concat(item.source);
    }
    return result;
  }, [item, preposition, actionName]);
  function AvatarComponent() {
    return !initials || forceIcon || brandIcon ? /*#__PURE__*/_jsx(IconAvatar, {
      icon: brandIcon || fallbackIcon
    }) : /*#__PURE__*/_jsx(Avatar, {
      color: "primary",
      initials: initials
    });
  }
  return [time, auditHistory, AvatarComponent];
};
export default useAuditTrail;